import { useEffect } from 'react';

/**
 * Wire `Escape` on the document to invoke `onClose` while `active` is true.
 *
 * Used by modal surfaces (BottomSheet, full-screen VendorDetail) so that
 * keyboard users can dismiss them without hunting for the close button.
 */
export function useEscClose(active: boolean, onClose: () => void): void {
  useEffect(() => {
    if (!active) return;
    function handleKey(event: KeyboardEvent) {
      if (event.key !== 'Escape') return;
      event.stopPropagation();
      onClose();
    }
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [active, onClose]);
}
